export default "__VITE_ASSET__DdWK7GtH__"